const fadeInUp = {
  animate: {
    translateY: [15, 0],
    opacity: [0, 1],
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut',
  },
};
export default fadeInUp;
